import React from 'react';
import Skeleton from 'react-loading-skeleton';

function SkeletonAvatar() {
  return <Skeleton className="rounded-pill wd-32 ht-32" />;
}

export default SkeletonAvatar;
